import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { BaseDetail } from 'projects/admin/src/app/classes/base-detail';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { DetailModes } from 'projects/admin/src/app/shared/constants';
import { RoleModel } from 'projects/core/src/lib/models/role.model';

@Component({
  selector: 'app-role-detail',
  templateUrl: './role-detail.component.html',
  styleUrls: ['./role-detail.component.scss']
})
export class RoleDetailComponent extends BaseDetail implements OnInit {

  public role: RoleModel = null;
  public backRoute = ['/roles'];
  public sysMode: string | null = null;

  protected identifier = 'role';

  constructor(
    protected ui: UiService,
    protected router: Router,
    protected helper: HelperService,
    protected transloco: TranslocoService,
    private api: ApiService,
    private route: ActivatedRoute,
    private auth: AuthStateService
  ) {
    super(ui, router, helper, transloco);
  }

  ngOnInit(): void {
    this.sysMode = this.auth.getSysMode();
    this.route.params.subscribe(params => {
      if (params.id === 'new') {
        this.setInitialized(DetailModes.new);
      } else if (params.id) {
        this.setLoading();
        this.api.getModel('roles', params.id).subscribe({
          next: (result: any) => {
            this.role = new RoleModel().deserialize(result.data);
            this.setInitialized(DetailModes.edit);
            setTimeout(() => {
              this.tabIndex = parseInt(localStorage.getItem(this.identifier + '-tab-' + this.role.id), 10);
            }, 0);
          },
          error: (error: any) => {
            this.setFailed(error);
          }
        });
      } else {
        this.onClose();
      }
    });
  }

  onTabChange(event: any): void {
    if (this.role !== null) {
      localStorage.setItem(this.identifier + '-tab-' + this.role.id, event.index);
    }
    this.ui.setFocus();
  }

}
